// Аллоулист совпадает с бековским (contract §7): бек режет молча, поэтому
// режем то же самое у себя — иначе автор увидит одно, а сохранится другое.
// `style`/`class` бек вырезает намеренно: цвета резолвятся из темы, не из разметки.
import DOMPurify from 'dompurify'
import type { Block } from '@/types/blocks'
import { DESIGN_TEXT_STUDIO_LIMIT } from './designElementDefaults'

const CONFIG = {
  ALLOWED_TAGS: ['p', 'br', 'b', 'strong', 'i', 'em', 'u', 'mark', 'span'],
  ALLOWED_ATTR: ['data-wavy'],
  KEEP_CONTENT: true,
  ALLOW_DATA_ATTR: false,
  ALLOW_ARIA_ATTR: false,
}

export const sanitizeDesignHtml = (html: string): string => DOMPurify.sanitize(html, CONFIG)

/** Длина текста для лимита: бек меряет 5000 (студия — с запасом, DESIGN_TEXT_STUDIO_LIMIT) по длине ОЧИЩЕННОГО html — самой
 *  строки sanitizeDesignHtml вернёт, теги и всё (contract §4.3, пример
 *  20797→4867 — т.е. после очистки меряется html, а не голый текст). Раньше
 *  здесь мерялся textContent (голый текст) — `<p>aaa</p><p>bbb</p>` давало 6
 *  вместо бековских 20, и длинный многоабзацный текст мог превысить лимит на
 *  сервере, пока счётчик ещё показывал запас. */
export const designTextLength = (html: string): number => sanitizeDesignHtml(html).length

/** Плейн-текст из разметки — для полей, которые рендерятся на КАЖДОЕ нажатие
 *  клавиши (heading textarea): DOMPurify.sanitize пересериализует разметку и
 *  экранирует одиночные `<`/`&`/`>`, набранные человеком (не тег — а автор
 *  печатает «Цена < 1000» — тут же превращается в «Цена &lt; 1000», и эта
 *  экранированная строка уходит в element.content). Чтение через
 *  `textContent` не сериализует обратно в HTML, поэтому голый `<` выживает. */
export const stripToPlainText = (html: string): string => {
  const el = document.createElement('div')
  el.innerHTML = html
  return el.textContent ?? ''
}

/** Текст дизайн-блока длиннее лимита бэка (на любом языке): такой PUT бэк отбивает
 *  422 целиком — слать его незачем, автору нужно сократить текст (kkc82). */
export const designTextOverLimit = (block: Block): boolean =>
  block.type === 'design' &&
  block.elements.some(
    (el) =>
      el.type === 'text' &&
      (designTextLength(el.content) > DESIGN_TEXT_STUDIO_LIMIT ||
        designTextLength(el.contentEn) > DESIGN_TEXT_STUDIO_LIMIT),
  )
